import { ReactLenis, useLenis } from "lenis/react";
import { ReactNode, useEffect } from "react";
import { setScrollDriver } from "@/lib/viewTransitions";

interface SmoothScrollProviderProps {
  children: ReactNode;
}

// Hands the Lenis instance to the page transition controller, which has to
// resync it after it jumps the scroll position on a navigation.
function LenisBridge() {
  const lenis = useLenis();
  useEffect(() => {
    if (!lenis) return;
    setScrollDriver(lenis as unknown as { resize: () => void; reset: () => void });
    return () => setScrollDriver(null);
  }, [lenis]);
  return null;
}

function SmoothScrollProvider({ children }: SmoothScrollProviderProps) {
  return (
    <ReactLenis
      root
      options={{
        lerp: 0.1,
        duration: 1.2,
        smoothWheel: true,
        wheelMultiplier: 1,
        touchMultiplier: 2,
        allowNestedScroll: true,
      }}
    >
      <LenisBridge />
      {children}
    </ReactLenis>
  );
}

export default SmoothScrollProvider;
